/**
 * WidgetTestPage - тестовая страница для VoiceWidget
 *
 * Позволяет протестировать все состояния виджета без подключения к API
 */

import { useState } from 'react';
import { VoiceWidget, getTheme } from '../components/VoiceWidget';
import { MorphIcon } from '../components/VoiceWidget/MorphIcon';

const mockMessages = [
  { id: '1', role: 'assistant', text: 'Hi! How can I help you today?' },
  { id: '2', role: 'user', text: 'I\'m looking for a used Honda Civic' },
  { id: '3', role: 'assistant', text: 'I found several Honda Civics in our inventory. Would you like me to show you the available options?' },
  { id: '4', role: 'system', text: 'Conversation started' },
];

export const WidgetTestPage = () => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [themeStyle, setThemeStyle] = useState('demo-shift-gears');
  const [themeMode, setThemeMode] = useState('light');
  const [accentMode, setAccentMode] = useState('off'); // 'off' | 'bg' | 'buttons'
  const [glassEffect, setGlassEffect] = useState(true);
  const [showWhatsApp, setShowWhatsApp] = useState(true);
  const [widgetTitle, setWidgetTitle] = useState('Ask us');
  const [messages, setMessages] = useState(mockMessages);

  const handleSendMessage = (text) => {
    const newMessage = {
      id: Date.now().toString(),
      role: 'user',
      text,
    };
    setMessages([...messages, newMessage]);

    // Simulate assistant response
    setTimeout(() => {
      setIsSpeaking(true);
      setTimeout(() => {
        setMessages(prev => [...prev, {
          id: (Date.now() + 1).toString(),
          role: 'assistant',
          text: `I received your message: "${text}". This is a mock response.`,
        }]);
        setIsSpeaking(false);
      }, 1500);
    }, 500);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      padding: '40px',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <h1 style={{ marginBottom: '20px' }}>VoiceWidget Test Page</h1>

      {/* Control panel */}
      <div style={{
        marginBottom: '40px',
        padding: '20px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}>
        <h3 style={{ marginBottom: '16px' }}>Controls</h3>

        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>

          <div>
            <label style={{ fontWeight: '500', marginRight: '8px' }}>Style:</label>
            <select
              value={themeStyle}
              onChange={(e) => setThemeStyle(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #ddd' }}
            >
              <option value="default">Default (B2B UI)</option>
              <option value="demo-shift-gears">Demo Shift Gears</option>
              <option value="andys">Andy's Motors</option>
            </select>
          </div>

          <div>
            <label style={{ fontWeight: '500', marginRight: '8px' }}>Theme Mode:</label>
            <div style={{
              display: 'inline-flex',
              gap: '4px',
              padding: '4px',
              background: '#f0f0f0',
              borderRadius: '6px',
            }}>
              <button
                onClick={() => setThemeMode('light')}
                style={{
                  padding: '6px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  background: themeMode === 'light' ? '#fff' : 'transparent',
                  color: themeMode === 'light' ? '#000' : '#666',
                  fontWeight: themeMode === 'light' ? '600' : '400',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: themeMode === 'light' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}
              >
                ☀️ Light
              </button>
              <button
                onClick={() => setThemeMode('dark')}
                style={{
                  padding: '6px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  background: themeMode === 'dark' ? '#fff' : 'transparent',
                  color: themeMode === 'dark' ? '#000' : '#666',
                  fontWeight: themeMode === 'dark' ? '600' : '400',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: themeMode === 'dark' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}
              >
                🌙 Dark
              </button>
            </div>
          </div>

          <div>
            <label style={{ fontWeight: '500', marginRight: '8px' }}>Accent:</label>
            <select
              value={accentMode}
              onChange={(e) => setAccentMode(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #ddd' }}
            >
              <option value="off">Off</option>
              <option value="bg">Accent bg</option>
              <option value="buttons">Accent buttons</option>
            </select>
          </div>

          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={glassEffect}
                onChange={(e) => setGlassEffect(e.target.checked)}
              />
              <span>Glass</span>
            </label>
          </div>

          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={showWhatsApp}
                onChange={(e) => setShowWhatsApp(e.target.checked)}
              />
              <span>WhatsApp</span>
            </label>
          </div>

          <div>
            <label style={{ fontWeight: '500', marginRight: '8px' }}>Title:</label>
            <input
              type="text"
              value={widgetTitle}
              onChange={(e) => setWidgetTitle(e.target.value.slice(0, 12))}
              maxLength={12}
              style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #ddd', width: '120px' }}
              placeholder="Ask us"
            />
          </div>

          <button
            onClick={() => setMessages([])}
            style={{
              padding: '8px 16px',
              background: '#666',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Clear Messages
          </button>
        </div>
      </div>

      {/* Widget display area */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '40px',
      }}>
        {/* All modes preview */}
        <div style={{
          width: '100%',
          padding: '40px',
          background: '#e8e8e8',
          borderRadius: '12px',
        }}>
          <p style={{ marginBottom: '24px', color: '#666', textAlign: 'center' }}>
            All states preview (static)
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '40px',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
          }}>
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '8px', fontSize: '14px', color: '#888' }}>Collapsed</p>
              <VoiceWidget
                mode="collapsed"
                isSpeaking={false}
                title={widgetTitle}
                showWhatsApp={showWhatsApp}
                theme={getTheme(themeStyle, themeMode, { accent: accentMode, glass: glassEffect })}
              />
            </div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '8px', fontSize: '14px', color: '#888' }}>Mini-collapsed (mobile)</p>
              <VoiceWidget
                mode="collapsed"
                isSpeaking={false}
                title={widgetTitle}
                showWhatsApp={showWhatsApp}
                isMini={true}
                theme={getTheme(themeStyle, themeMode, { accent: accentMode, glass: glassEffect })}
              />
            </div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '8px', fontSize: '14px', color: '#888' }}>MorphIcon (standalone)</p>
              <div style={{ display: 'inline-flex', background: '#fff', borderRadius: '50%', padding: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <MorphIcon size={48} iconSize={20} />
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '8px', fontSize: '14px', color: '#888' }}>Voice (speaking)</p>
              <VoiceWidget
                mode="voice"
                isSpeaking={true}
                theme={getTheme(themeStyle, themeMode, { accent: accentMode, glass: glassEffect })}
              />
            </div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '8px', fontSize: '14px', color: '#888' }}>Chat</p>
              <VoiceWidget
                mode="chat"
                messages={mockMessages}
                isSpeaking={false}
                width={380}
                height={450}
                theme={getTheme(themeStyle, themeMode, { accent: accentMode, glass: glassEffect })}
                onCollapseToVoice={() => console.log('Collapse clicked')}
                onClose={() => console.log('Close clicked')}
              />
            </div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '8px', fontSize: '14px', color: '#888' }}>Chat (session active)</p>
              <VoiceWidget
                mode="chat"
                messages={mockMessages}
                isSessionActive={true}
                title="Janette"
                width={380}
                height={450}
                theme={getTheme(themeStyle, themeMode, { accent: accentMode, glass: glassEffect })}
                onCollapseToVoice={() => console.log('Collapse clicked')}
                onClose={() => console.log('Close clicked')}
                renderControls={() => (
                  <div style={{ textAlign: 'center', padding: '8px', color: '#666', fontSize: '12px' }}>
                    [VoiceBar / ChatPanel input]
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetTestPage;
